module.exports = __webpack_public_path__ + "img/person_dark.30199a6d.svg";